/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GDPRConsent } from './GDPRConsent';
import {
    GDPRConsentFromJSON,
    GDPRConsentFromJSONTyped,
    GDPRConsentToJSON,
} from './GDPRConsent';

/**
 * 
 * @export
 * @interface GDPRConsentResponse
 */
export interface GDPRConsentResponse {
    /**
     * 
     * @type {Array<GDPRConsent>}
     * @memberof GDPRConsentResponse
     */
    consents: Array<GDPRConsent>;
}

/**
 * Check if a given object implements the GDPRConsentResponse interface.
 */
export function instanceOfGDPRConsentResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "consents" in value;

    return isInstance;
}

export function GDPRConsentResponseFromJSON(json: any): GDPRConsentResponse {
    return GDPRConsentResponseFromJSONTyped(json, false);
}

export function GDPRConsentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GDPRConsentResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'consents': ((json['consents'] as Array<any>).map(GDPRConsentFromJSON)),
    };
}

export function GDPRConsentResponseToJSON(value?: GDPRConsentResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'consents': ((value.consents as Array<any>).map(GDPRConsentToJSON)),
    };
}

